export enum EventPaymentType {
    ONLINE_PAYMENT = 1,
    PAYMENT_BY_BANK_TRANSFER = 2
}
